import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=29eec254&scoped=true"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"
import style0 from "../../style/chat-view.scss?vue&type=style&index=0&id=29eec254&prod&lang=scss&scoped=true&external"
import style1 from "./SystemMessage.vue?vue&type=style&index=1&id=29eec254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eec254",
  null
  
)

export default component.exports